module.exports = __webpack_public_path__ + "img/h5.40bb610b.png";